import React from 'react'
import { observer } from 'mobx-react'
import { observable, reaction } from 'mobx'
import { Button, Col, Row } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { CommonForm } from 'src/views/components'
import { changeAccountCardForm } from './formInput'
import { schema } from './validationSchema'
import { pageNames } from 'src/routes/pathParams'
import {
  accountsContainer,
  customerContainer,
  storeContainer,
} from 'src/models'
import {
  i18nTranslate,
  convertToBoolean,
  getSponsorInfo,
  isGuestCheckoutEnabledForWeb,
  enablePhoneVerificationForConversion,
  getLocaleCodeFromUrl,
  IS_BROWSER,
  getLocalePathParam,
  isLATAM,
  isPAC,
  getAccountTypes,
  isFeatureEnabled,
} from 'src/utils'
import SponsorSwitchModal from 'src/views/components/SponsorSwitchModal/SponsorSwitchModal'
import ConversionSuccessPopup from 'src/views/components/BAConversionModal/ConversionSuccessPopup'
import ConversionFailPopup from 'src/views/components/BAConversionModal/ConversionFailPopup'
import SponsorChangePopUp from 'src/views/components/SponsorSwitchModal/sponsorChangePopUp'
import {
  APPConfig,
  getLocalStorage,
  getSessionStorage,
  deleteFromSessionStorage,
} from 'config/appConfig'
import { accountTypeTranslation } from 'src/deps'
import { trackGTMEvents } from 'src/utils'
import PhoneVerificationModal from 'src/views/components/PhoneVerificationModal/PhoneVerificationModal'
import AccountConvertedSuccessPopup from 'src/views/components/BAConversionModal/AccountConvertedSuccessPopup'
import getLatamTaxInputs, { isHomeCountry } from 'src/utils/legalTaxUtils'

@observer
class ChangeAccountTypeCard extends React.Component {
  @observable sponsorName = ''
  @observable sponsorId = 'RETFLOAT'
  @observable showModalBox = false
  @observable showConversionSuccessModal = false
  @observable showConversionFailModal = false
  @observable isSponsorChanged = false
  @observable sponsorFromLink = ''
  @observable isSameSponsor = false
  @observable isToShowBrandAffiliatePopup = false
  @observable isToShowRetailErrorPopUp = false
  @observable showPhoneVerificationModal = false
  @observable isPhoneNumberVerified = false
  @observable isEmailVerified = false
  @observable isDownConvertPhoneVerify = true
  @observable sponsorInfo = {}
  @observable fromAccountprofile = false
  @observable showAccountConvertedSuccessModal = false
  @observable failureApiStatus = false
  @observable isUserDataExists = false
  @observable isLegalTaxDataLoaded = false

  constructor(props) {
    super(props)
    this.state = {
      isButtonLoading: true,
    }
  }
  enableLegalTaxId = convertToBoolean(
    APPConfig?.getAppConfig()?.enableLegalTaxId
  )
  handleConversionFailPopup = () => {
    this.showConversionFailModal = false
    this.showConversionSuccessModal = true
  }

  handleConversionSuccessPopup = () => {
    this.showConversionSuccessModal = false
    trackGTMEvents({
      event: 'account type consent',
      account_type: 'BA to Member',
      consent: 'reject',
      platform: 'equinox',
    })
  }
  handleBecomeAMemberButton = () => {
    this.showConversionSuccessModal = true
    accountsContainer.selectedAccountType = 'Preferred Customer/Member'
    trackGTMEvents({
      event: 'account type',
      account_type: 'BA to Member',
      platform: 'equinox',
    })
  }

  handleBecomeABrandAffiliate = () => {
    const { currentAccountType, convertingAccountType } = getAccountTypes(
      accountsContainer,
      customerContainer
    )
    trackGTMEvents({
      event: 'account type',
      account_type: `${currentAccountType} to ${convertingAccountType}`,
    })
  }

  handleClosePhoneVerification = () => {
    this.showPhoneVerificationModal = false
  }
  handleShowPhoneVerificationModal = () => {
    if (
      enablePhoneVerificationForConversion() &&
      !this.isPhoneNumberVerified &&
      !this.isEmailVerified
    ) {
      this.showPhoneVerificationModal = true
      this.fromAccountprofile = true
    } else {
      this.showPhoneVerificationModal = false
      if (!enablePhoneVerificationForConversion()) {
        this.props?.handleShowDownConvertForm(true)
      } else if (this.isPhoneNumberVerified || this.isEmailVerified) {
        this.props?.handleShowDownConvertForm(true)
      }
    }
    this.showConversionSuccessModal = false
    trackGTMEvents({
      event: 'account type consent',
      account_type: 'BA to Member',
      consent: 'accept',
      platform: 'equinox',
    })
  }

  async componentDidMount() {
    await this.init()
    await this.queryParamsCheck()
    await this.getPhoneVerficationValue()
    await this.getEmailVerficationValue()
    if (this.enableLegalTaxId) {
      await this.getLegalTaxInfo()
    }
    const reactions = reaction(
      () => this.showModalBox,
      async (value, reaction) => {
        if (value === false && this.isSponsorChanged) {
          const accountId =
            customerContainer?.profileResponse?.accounts?.referenceAttribute ||
            ''
          await accountsContainer?.getProfile(accountId)
          await this.init()
        }
      }
    )
  }
  getLegalTaxInfo = async () => {
    const isHomeCountryUser = customerContainer?.isRegisterUser
      ? isHomeCountry()
      : true
    const accountType =
      customerContainer?.profileResponse?.accounts?.accountType ||
      getLocalStorage('accountType') ||
      ''
    if (
      this.enableLegalTaxId &&
      isHomeCountryUser &&
      accountType === 'Brand Affiliate'
    ) {
      const enableAPIForJson = !convertToBoolean(
        APPConfig?.getAppConfig()?.enableLegalTaxStaticJson
      )
      if (enableAPIForJson) {
        const locale = getLocalePathParam()?.split('/')
        await accountsContainer.getLegalTaxInputs({
          countryCode: locale[0],
          language: locale[1],
        })
      }
      await accountsContainer?.getTaxIdDetails()
      const { isUserDataExists } = await getLatamTaxInputs()
      this.isUserDataExists = isUserDataExists
      this.isLegalTaxDataLoaded = true
    }
    this.setState({ isButtonLoading: false })
  }

  getPhoneVerficationValue = () => {
    this.isPhoneNumberVerified = convertToBoolean(
      customerContainer?.profileResponse?.customProperties
        ?.isPhoneNumberVerified || false
    )
  }

  getEmailVerficationValue = () => {
    this.isEmailVerified = convertToBoolean(
      customerContainer?.profileResponse?.customProperties
        ?.isEmailVerifiedFlag || false
    )
  }

  handleSignOutClick = async () => {
    const activeLocale = getLocaleCodeFromUrl({
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    const localeInUrl = activeLocale?.toLowerCase()?.split('_')
    const currentUrlLocale = `${localeInUrl[1]}/${localeInUrl[0]}`
    await customerContainer.logout()
    // reloading page hence intiate the applicaton
    if (IS_BROWSER) {
      window.location.reload()
      const newUrl = `${window.location.origin}/${currentUrlLocale}`
      window.location.href = newUrl
    }
  }

  handleShowAccountConvertedSuccessModalClose = () => {
    this.showAccountConvertedSuccessModal = false
    this.handleSignOutClick()
  }

  // checkConversionStatus = async accountId => {
  //   const response = await accountsContainer.getConversionStatus(accountId)
  //   if (
  //     accountsContainer.isSuccessResponse(response) &&
  //     response.responseStatus == 'success'
  //   ) {
  //     this.showAccountConvertedSuccessModal = true
  //   } else {
  //     this.failureApiStatus = true
  //     console.log(this.failureApiStatus)
  //   }
  // }

  /**
   * @description - init function handle the sponsor ID check and prefill the sponsor name when component is initally loaded and every time if sponsor is changed for that acccount
   * @date 10/12/2023 - 12:31:09 PM
   *
   * @async
   * @returns { void }
   */

  init = async () => {
    const enableDownCovert = convertToBoolean(
      APPConfig?.getAppConfig()?.enableDownCovert
    )
    const enableFourMonthNotification = convertToBoolean(
      APPConfig?.getAppConfig()?.enableFourMonthNotification
    )
    await customerContainer?.getProfile({ fromOnLoad: true })
    const accountId =
      customerContainer?.profileResponse?.accounts?.referenceAttribute || ''

    const accProperties =
      accountsContainer?.profileResponse?.properties ||
      customerContainer?.profileResponse?.accounts?.properties

    let homeCountry = storeContainer.currentRegion || ''

    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      (element = {}) => {
        if (element.attributeId === 'countryCode') {
          homeCountry = element.value
        }
      }
    )

    if (homeCountry === 'CA') {
      homeCountry = 'Canada'
    }
    if (
      (accountsContainer.isAccountIsBA || accountsContainer.isAccountIsBE) && // Mandatory condition
      ((!enableFourMonthNotification && enableDownCovert) || // Condition 1
        (enableFourMonthNotification && !enableDownCovert) || // Condition 2
        (enableFourMonthNotification && enableDownCovert)) &&
      homeCountry === storeContainer.storeIDValue
    ) {
      await accountsContainer?.getCommissionCall()
      const response = await accountsContainer.getConversionStatus(accountId)
      if (
        accountsContainer.isSuccessResponse(response) &&
        response.responseStatus == 'success'
      ) {
        this.showAccountConvertedSuccessModal = true
      } else if (
        accountsContainer.isSuccessResponse(response) &&
        response.responseStatus != 'success' &&
        response.responseStatus != 'InProgress' &&
        response.responseStatus != 'failure'
      ) {
        this.failureApiStatus = true
      }
    }

    const spid =
      accProperties &&
      accProperties.find(list => list.attributeId === 'sponsorId')
    const sponsorId = spid?.value || ''
    this.sponsorInfo = getSponsorInfo(sponsorId)
    this.sponsorId = sponsorId
    if (sponsorId !== 'RETFLOAT') {
      this.sponsorName = await customerContainer?.sponsorIdValidation(sponsorId)
    }
  }

  /**
   * @description - queryParamsCheck function check if the account profile page is accessed through sponsor change invitation link.
   * It checks two query params switchsponsor and sponsor.If present the sponsor switch modal popup opens on default.
   * @date 10/12/2023 - 12:28:12 PM
   * @returns {void}
   */
  queryParamsCheck = async () => {
    const sponsorChange = getSessionStorage('switchsponsor') || ''
    const sponsorIdInSession = getSessionStorage('conv-sponsor') || ''
    const accountType =
      customerContainer?.profileResponse?.accounts?.accountType ||
      getLocalStorage('accountType') ||
      ''
    if (sponsorChange === 'ok' && sponsorIdInSession !== '') {
      if (accountType === 'Brand Affiliate') {
        this.isToShowBrandAffiliatePopup = true
      } else if (
        accountType !== 'Brand Affiliate' &&
        accountType !== 'Retail Customer'
      ) {
        this.isToShowRetailErrorPopUp = true
      } else if (this.sponsorId === sponsorIdInSession) {
        this.isSameSponsor = true
      } else {
        this.sponsorFromLink = sponsorIdInSession
        this.showModalBox = true
      }
    }
  }

  /**
   * @description - handleSubmit function navigates user to convert Account page
   * @date 10/12/2023 - 12:26:46 PM
   * @return {void}
   */
  handleSubmit = () => {
    deleteFromSessionStorage('conv-sponsor')
    deleteFromSessionStorage('mem')
    if (
      typeof this.props?.history !== 'undefined' &&
      this.props?.history !== ''
    )
      this.props?.history?.push(pageNames?.b2bAccountTypeConvert)
  }

  /**
   * @description - handleModal function update the showModalBox state variable which handles the open and close of modal popup,
   * this function is sent as prop to sponsor switch modal to handle the close and switch my sponsor button click events
   * @date 10/12/2023 - 12:20:36 PM
   *
   * @param {boolean} [isFromSwitchButton=false]
   */
  handleModal = (isFromSwitchButton = false) => {
    this.isSponsorChanged = isFromSwitchButton
    this.showModalBox = !this.showModalBox
    if (this.sponsorFromLink) {
      this.props?.history?.push(pageNames?.b2bAccountProfile)
    }
    deleteFromSessionStorage('conv-sponsor')
    deleteFromSessionStorage('switchsponsor')
  }

  /**
   * @description - submitButtonProps return two button element Upgrade button and Switch my Sponsor  sponsor button
   * @date 10/12/2023 - 12:17:00 PM
   *
   * @returns { JSX.Element }
   */
  shouldRestrictBaBeConversion = () => {
    const restrictedBaBeAccountConversion =
      accountsContainer?.profileResponse?.additionalProperties
        ?.restrictedAccountConversions || ''
    const accountType =
      customerContainer?.profileResponse?.accounts?.accountType || ''
    const isBa = accountType === 'Brand Affiliate'
    const shouldRestrict = restrictedBaBeAccountConversion.includes('BA_2_BE')
    return isBa && shouldRestrict
  }

  renderSkeletonLoading = ({
    isDisableForConversion,
    isValidForConversion,
    isValidHouseSponsor,
    isValidForSwitch,
    enableDownCovert,
    enableFourMonthNotification,
  }) => {
    return (
      <Col className="p-0">
        {/* Skeleton for error message - only if it would be shown */}
        {isDisableForConversion && (
          <Skeleton
            rectangle={true}
            height={16}
            width="80%"
            containerClassName="text-danger my-2 small"
          />
        )}

        <Row className="d-flex flex-column account-type-btn">
          {/* Skeleton for first button - only if isValidForConversion */}
          {isValidForConversion && !isValidHouseSponsor && (
            <Col xs={12} md={6} lg={6} className="mb-2 pr-1">
              <Skeleton
                rectangle={true}
                height={38}
                containerClassName="w-100"
                className="updateSponsorBtn"
              />
            </Col>
          )}

          {/* Skeleton for Member conversion button - only if conditions match */}
          {(accountsContainer.isAccountIsBA ||
            accountsContainer.isAccountIsBE) &&
            ((!enableFourMonthNotification && enableDownCovert) ||
              (enableFourMonthNotification && !enableDownCovert) ||
              (enableFourMonthNotification && enableDownCovert)) && (
              <Col xs={12} md={6} lg={6} className="pr-1 mb-2">
                <Skeleton
                  rectangle={true}
                  height={38}
                  containerClassName="w-100"
                  className="updateSponsorBtn"
                />
              </Col>
            )}
        </Row>

        {/* Skeleton for sponsor switch button - only if isValidForSwitch */}
        {isValidForSwitch && !isValidHouseSponsor && (
          <Skeleton
            rectangle={true}
            height={38}
            width="200px"
            containerClassName="mb-2"
            className="switchSponsorBtn"
          />
        )}

        {/* Skeleton for notification messages - conditional based on account status */}
        {accountsContainer?.accountConversionStatus?.toLowerCase() ===
          'inprogress' && (
          <Skeleton
            rectangle={true}
            height={14}
            width="90%"
            containerClassName="small mt-2"
          />
        )}

        {/* Skeleton for failure message */}
        {this.failureApiStatus && (
          <Skeleton
            rectangle={true}
            height={14}
            width="85%"
            containerClassName="text-danger my-2 small"
          />
        )}

        {/* Skeleton for error messages - only if there would be messages */}
        <div className="small mt-3">
          {this.getMessage()?.length > 0 &&
            this.getMessage()?.map((msg, index) => (
              <Skeleton
                key={index}
                rectangle={true}
                height={14}
                width={`${Math.max(75, 85 - index * 10)}%`}
                containerClassName="text-danger small mb-2"
              />
            ))}
        </div>
      </Col>
    )
  }

  getMessage = () => {
    const accountType =
      customerContainer?.profileResponse?.accounts?.accountType || ''
    const messages = []
    const enableDownCovert = convertToBoolean(
      APPConfig?.getAppConfig()?.enableDownCovert
    )
    const enableFourMonthNotification = convertToBoolean(
      APPConfig?.getAppConfig()?.enableFourMonthNotification
    )
    const restrictedBaBeAccountConversion = this.shouldRestrictBaBeConversion()

    if (restrictedBaBeAccountConversion) {
      messages.push(
        i18nTranslate(
          'sponsorChange.restrictedBaBeAccountConversion',
          'Brand Affiliate accounts are not eligible to convert to a Business account online. Please contact distributor support or your account manager for more information.'
        )
      )
    } else if (
      (accountsContainer.isAccountIsBA || accountsContainer.isAccountIsBE) && // Mandatory condition
      ((!enableFourMonthNotification && enableDownCovert) || // Condition 1
        (enableFourMonthNotification && !enableDownCovert) || // Condition 2
        (enableFourMonthNotification && enableDownCovert))
    ) {
      if (!accountsContainer?.isComissionCallInProgress) {
        messages.push(
          i18nTranslate(
            'ba_to_member_feature_not_available',
            'This feature is not currently available due to the commission run in progress. Please check back later.'
          )
        )
      } else {
        if (accountsContainer.isAccountIsBE) {
          messages.push(
            i18nTranslate(
              'ba_to_member_account_is_not_be_error',
              'Business Entity and Joint Brand Affiliate accounts are not eligible to change to a Member account online. Please contact distributor support or your account manager for more information.'
            )
          )
        }
        if (accountsContainer.isAccountHold) {
          messages.push(
            i18nTranslate(
              'ba_to_member_account_hold_error',
              'Your account has a hold and is not eligible to change to a Member account type online. Please contact distributor support or your account manager for more information.'
            )
          )
        }
        if (accountsContainer.checkNumberOfBuyers) {
          messages.push(
            i18nTranslate(
              'ba_to_member_account_is_not_be_error',
              'Business Entity and Joint Brand Affiliate accounts are not eligible to change to a Member account online. Please contact distributor support or your account manager for more information.'
            )
          )
        }
      }
    }
    return messages
  }

  submitButtonProps = () => {
    accountsContainer.checkAccountStatus(accountsContainer)
    const enableDownCovert = convertToBoolean(
      APPConfig?.getAppConfig()?.enableDownCovert
    )
    const enableFourMonthNotification = convertToBoolean(
      APPConfig?.getAppConfig()?.enableFourMonthNotification
    )
    const enableJITSU = convertToBoolean(APPConfig?.getAppConfig()?.enableJITSU)
    const accountType =
      customerContainer?.profileResponse?.accounts?.accountType || ''
    const convertingAccount =
      accountType === 'Brand Affiliate'
        ? 'Brand Affiliate - Business Entity'
        : 'Brand Affiliate'
    const isValidForSwitch =
      (this.sponsorId !== 'RETFLOAT' && accountType === 'Retail Customer') ||
      false
    const isToEnabePM2BAConversion =
      APPConfig?.getAppConfig()?.FEATURE_PM2BA_CONVERSION === 'true' || false
    const taxId = customerContainer?.profileResponse?.accounts?.taxNumber || ''
    const isValidForConversion =
      accountType === 'Preferred Customer/Member'
        ? isToEnabePM2BAConversion
        : (this.sponsorId !== 'RETFLOAT' &&
            accountType !== 'Brand Affiliate - Business Entity') ||
          false
    let isDisableForConversion = false
    const restrictedBaBeAccountConversion = this.shouldRestrictBaBeConversion()

    if (
      convertToBoolean(APPConfig?.getAppConfig()?.enableJITSU) &&
      accountType === 'Brand Affiliate'
    ) {
      if (isLATAM()) {
        if (!this.isLegalTaxDataLoaded) {
          isDisableForConversion = false
        } else {
          isDisableForConversion =
            restrictedBaBeAccountConversion || !this.isUserDataExists
        }
      } else if (isPAC()) {
        isDisableForConversion = restrictedBaBeAccountConversion
      } else {
        isDisableForConversion =
          restrictedBaBeAccountConversion || taxId === 'NA1' || taxId === ''
      }
    }

    let isValidHouseSponsor = false
    const enabledGuestForWeb = isGuestCheckoutEnabledForWeb()

    if (
      enabledGuestForWeb &&
      accountType === 'Retail Customer' &&
      this.sponsorInfo.isInHouseSponsor
    ) {
      isValidHouseSponsor = true
    }
    // if (enablePhoneVerification()) {
    //   return (
    //     <Col className="p-0 ">
    //       <hr />
    //       {isValidForSwitch && (
    //         <div className="mb-3 mt-3">
    //           <Button
    //             variant="outline-primary"
    //             className={isValidForSwitch ? 'switchSponsorBtn minWidth' : 'd-none'}
    //             onClick={() => (this.showModalBox = true)}>
    //             {i18nTranslate('sponsorChange.switch', 'Change my Sponsor')}
    //           </Button>
    //         </div>
    //       )}
    //       {isValidForConversion && (
    //         <div>
    //           <Button
    //             type="submit"
    //             variant="primary"
    //             className={
    //               isValidForConversion ? 'updateSponsorBtn minWidth' : 'd-none'
    //             }>
    //             {i18nTranslate('sponsorChange.upgrade', 'Upgrade to ') +
    //               accountTypeTranslation(convertingAccount)}
    //           </Button>
    //         </div>
    //       )}
    //     </Col>
    //   )
    // }

    if (this.state.isButtonLoading) {
      return this.renderSkeletonLoading({
        isDisableForConversion,
        isValidForConversion,
        isValidHouseSponsor,
        isValidForSwitch,
        enableDownCovert,
        enableFourMonthNotification,
      })
    }
    const shouldHideBEConversion =
      accountType === 'Brand Affiliate' && !isFeatureEnabled('BEConversion')
    const shouldHideBEConversionErrors =
      accountType === 'Brand Affiliate' &&
      !isFeatureEnabled('BEConversionErrors')
    return (
      <Col className="p-0">
        {isDisableForConversion && !shouldHideBEConversionErrors && (
          <div className="text-danger my-2 small">
            {i18nTranslate(
              'sponsorChange.disableConvertTo',
              'A tax id is required. Please visit V&G Preferences or Stela Profile to add.'
            )}
          </div>
        )}
        <Row className="d-flex flex-column account-type-btn">
          {isValidForConversion &&
            !isValidHouseSponsor &&
            !shouldHideBEConversion && (
              <Col xs={12} md={6} lg={6} className="mb-2 pr-1">
                <Button
                  type="submit"
                  variant="outline-primary"
                  disabled={isDisableForConversion}
                  onClick={this.handleBecomeABrandAffiliate}
                  className={
                    isValidForConversion ? 'updateSponsorBtn w-100' : 'd-none'
                  }>
                  {(enableJITSU
                    ? i18nTranslate('sponsorChange.Become', 'Become a ')
                    : i18nTranslate('sponsorChange.convertTo', 'Convert to ')) +
                    accountTypeTranslation(convertingAccount)}
                </Button>
              </Col>
            )}
          {(accountsContainer.isAccountIsBA ||
            accountsContainer.isAccountIsBE) && // Mandatory condition
            ((!enableFourMonthNotification && enableDownCovert) || // Condition 1
              (enableFourMonthNotification && !enableDownCovert) || // Condition 2
              (enableFourMonthNotification && enableDownCovert)) && (
              <Col xs={12} md={6} lg={6} className="pr-1 mb-2">
                <Button
                  variant="outline-primary"
                  disabled={
                    accountsContainer.isAccountIsBE ||
                    accountsContainer.isAccountHold ||
                    !accountsContainer?.isComissionCallInProgress ||
                    !accountsContainer?.isComissionCalled ||
                    accountsContainer.checkNumberOfBuyers ||
                    accountsContainer.accountConversionStatus === 'InProgress'
                  }
                  onClick={this.handleBecomeAMemberButton}
                  className="updateSponsorBtn w-100">
                  {accountsContainer.accountConversionStatus === 'InProgress'
                    ? i18nTranslate(
                        'ba_to_member_member_pending_switch',
                        'Switch to Member pending'
                      )
                    : i18nTranslate(
                        'ba_to_member_switch_to_a_member_account',
                        'Switch to a Member Account'
                      )}
                </Button>
              </Col>
            )}
        </Row>
        {isValidForSwitch && !isValidHouseSponsor && (
          <Button
            variant="outline-primary"
            className={isValidForSwitch ? 'switchSponsorBtn' : 'd-none'}
            onClick={() => (this.showModalBox = true)}>
            {i18nTranslate('sponsorChange.switch', 'Change my Sponsor')}
          </Button>
        )}
        {accountsContainer?.accountConversionStatus?.toLowerCase() ===
          'inprogress' && (
          <div className="small mt-2">
            {i18nTranslate(
              'ba_to_member_email_notification',
              'We’ll send you an email notification with more info when this is ready.'
            )}
          </div>
        )}
        {this.failureApiStatus && (
          <div className="text-danger my-2 small">
            {i18nTranslate(
              'ba_to_member_unable_to_process_request',
              'We were unable to process your request to become a Member due to an unexpected error. Please try again.'
            )}
          </div>
        )}
        <div className="small mt-3">
          {this.getMessage()?.length > 0 &&
            !shouldHideBEConversionErrors &&
            this.getMessage()?.map((msg, index) => (
              <div className="text-danger small mb-2" key={index}>
                {msg}
              </div>
            ))}
        </div>
      </Col>
    )
  }

  render() {
    return (
      <div>
        <CommonForm
          formTypeJson={changeAccountCardForm({
            firstName: this.sponsorName?.firstName || '',
            lastName: this.sponsorName?.lastName || '',
            preferredName: this.sponsorName?.preferredName || '',
            sponsorId: this.sponsorId,
          })}
          schema={schema()}
          onSubmit={this.handleSubmit}
          hasInlineSubmitButton={false}
          SubmitButtonProps={this.submitButtonProps}
          isUserDataExists={this.isUserDataExists}
        />
        {this.showModalBox && (
          <SponsorSwitchModal
            showModal={this.showModalBox}
            handleModal={this.handleModal}
            sponsorFromLink={this.sponsorFromLink}
          />
        )}
        {this.showConversionSuccessModal && (
          <ConversionSuccessPopup
            showModal={this.showConversionSuccessModal}
            handleConversionSuccessPopup={this.handleConversionSuccessPopup}
            handleShowPhoneVerificationModal={
              this.handleShowPhoneVerificationModal
            }
          />
        )}
        {this.showConversionFailModal && (
          <ConversionFailPopup
            showModal={this.showConversionFailModal}
            handleConversionFailPopup={this.handleConversionFailPopup}
          />
        )}
        {this.showPhoneVerificationModal && (
          <PhoneVerificationModal
            fromSessionCheck={true}
            fromAccountprofile={this.fromAccountprofile}
            handleShowDownConvertForm={this.props?.handleShowDownConvertForm}
            handleClosePhoneVerification={this.handleClosePhoneVerification}
            isDownConvertPhoneVerify={this.isDownConvertPhoneVerify}
            showModal={this.showPhoneVerificationModal}
          />
        )}
        {this.showAccountConvertedSuccessModal && (
          <AccountConvertedSuccessPopup
            showModal={this.showAccountConvertedSuccessModal}
            handleShowAccountConvertedSuccessModalClose={
              this.handleShowAccountConvertedSuccessModalClose
            }
          />
        )}
        {(this.isSameSponsor ||
          this.isToShowBrandAffiliatePopup ||
          this.isToShowRetailErrorPopUp) && (
          <SponsorChangePopUp
            isFromAccountProfile={true}
            isSameSponsor={this.isSameSponsor}
            isToShowBrandAffiliatePopup={this.isToShowBrandAffiliatePopup}
            isToShowRetailErrorPopUp={this.isToShowRetailErrorPopUp}
            sponsorName={this.sponsorName || ''}
            history={this.props?.history}
            isToShowPopUp={
              this.isSameSponsor ||
              this.isToShowBrandAffiliatePopup ||
              this.isToShowRetailErrorPopUp
            }
          />
        )}
      </div>
    )
  }
}
export default ChangeAccountTypeCard
export { ChangeAccountTypeCard }
